import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutDashboardContext from '../../services/inOutDashboard/InOutDashboardContext';

import { CCUS_SEND_RESULT, DATE_TIME_FORMAT } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

import Styles from '../../styles/componentStyle/inOutDashboard/InOutDashboard.scss';
import TransmissionErrorResult from '../modals/TransmissionErrorResult';

/**
 * ダッシュボードお知らせリスト
 * */
export const NewsList = () => {
  // 画面表示
  return (
    <InOutDashboardContext.Consumer>
      {({ state, closeDialog, selectTransmissionHistory }) => (
        <React.Fragment>
          <ul className={Styles.newsList}>
            {state.ccusSecededWarning && (
              <li className='text-warning-ccus'>
                 {messageUtility.getMessage(
                  state.jvFlag ? 'I-002-013-01' : 'I-002-013-05'
                )}
              </li>
            )}
            {_.map(state.newsList, (item, index) => {
              if (item.ccus_send_result === CCUS_SEND_RESULT.failed.key) {
                return (
                  <li className={item.ccus_send_result} key={index}>
                    <p>
                      <span className='notice-error'>
                        {moment(new Date(item.sent_at).toISOString()).format(
                          DATE_TIME_FORMAT.slashDateTimeFormatNoYear
                        )}{' '}
                        {item.message}
                      </span>
                      <button
                        className='btn--contained'
                        onClick={() => selectTransmissionHistory(item)}
                      >
                        確認
                      </button>
                    </p>
                  </li>
                );
              } else {
                return (
                  <li className={item.ccus_send_result} key={index}>
                    {moment(new Date(item.sent_at).toISOString()).format(
                      DATE_TIME_FORMAT.slashDateTimeFormatNoYear
                    )}{' '}
                    {item.message}
                  </li>
                );
              }
            })}
          </ul>

          <TransmissionErrorResult
            fieldId={state.field.id}
            checkInOutLogTransmissionHistoryId={
              state.selectedTransmissionHistoryId
            }
            isOpened={state.isOpened}
            onClose={closeDialog}
          />
        </React.Fragment>
      )}
    </InOutDashboardContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/components/list/InOutDashboardNewsList.jsx